import EventAggregator from '@classic/AppUtils/Framework/Messaging/EventAggregator'
import { IEventAggregator } from '@classic/AppUtils/Framework/Messaging/IEventAggregator'
import container from '@classic/Betting-v2/IOC/inversify.config'

export function getEventAggregator<T extends IEventAggregator = EventAggregator>(): T {
  return container.get<T>('IEventAggregator')
}
